<template>
	<div v-if="scriptsLoaded">
		<slot />
	</div>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
	name: 'AddressMapWrapper',
	setup() {
		const scriptsLoaded = ref(false)

		const loadExternalAssets = async () => {
			const head = document.head

			const stylesheets = [
				'https://www.salzburg.gv.at/sagismobile/content/portal.css?5.24.1101',
				'https://www.salzburg.gv.at/sagismobile/content/companies/sagis/portal.css?5.24.1101',
				'https://www.salzburg.gv.at/api5/content/styles/default.css?5.24.1101',
				'https://www.salzburg.gv.at/api5/content/styles/sagis/default.css?5.24.1101',
				'https://www.salzburg.gv.at/api5/content/api/ui.css?5.24.1101',
				'https://www.salzburg.gv.at/api5/scripts/api/plugins/smartmap/smartmap.css',
			]

			stylesheets.forEach((url) => {
				const link = document.createElement('link')
				link.rel = 'stylesheet'
				link.href = url
				head.appendChild(link)
			})

			const scripts = [
				'https://www.salzburg.gv.at/api5/scripts/jquery-3.4.1.min.js',
				'https://www.salzburg.gv.at/api5/scripts/typeahead/typeahead.jquery.min.js',
				'https://www.salzburg.gv.at/api5/scripts/api/api.min.js?5.24.1101',
				'https://www.salzburg.gv.at/api5/scripts/api/api-ui.min.js?5.24.1101',
				'https://www.salzburg.gv.at/api5/scripts/api/plugins/smartmap/smartmap.js',
				'https://www.salzburg.gv.at/sagismobile/scripts/webgis-map.js?5.24.1101',
			]

			for (const src of scripts) {
				if (src === 'https://www.salzburg.gv.at/api5/scripts/api/api.min.js?5.24.1101') {
					await loadScript(src, 'webgis-api-script')
				} else {
					await loadScript(src)
				}
			}

			scriptsLoaded.value = true
		}

		const loadScript = (src, id) => {
			return new Promise((resolve, reject) => {
				const script = document.createElement('script')
				script.src = src
				if (id) {
					script.id = id
				}
				script.onload = () => resolve(src)
				script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
				document.body.appendChild(script)
			})
		}

		onMounted(() => {
			loadExternalAssets()
		})

		return {
			scriptsLoaded,
		}
	},
}
</script>

<style lang="css">
#smartmap-container {
	inset: 0 !important;
	width: 100% !important;
	height: 100% !important;
	padding: 0 !important;
}

html body {
	overscroll-behavior-y: unset !important;
	background-color: unset !important;
}

/** Disable user input field */
.twitter-typeahead {
	display: none !important;
}

/** Disable current position button */
.tool-webgis-tools-currentposition {
	display: none !important;
}

#map {
}

.tabs {
	padding: 0px;
	margin: 0px;
}

.tab {
	display: inline-block;
	padding: 4px 8px;
	font-weight: bold;
	cursor: pointer;
}

.tab.selected {
	background: #808080;
	color: white;
}

.tab:hover {
	background: #aaa;
}
</style>
